import React from 'react';

function Dropdown({ options, value, onChange, placeholder, name }) {
  return (
    <select
      name={name}
      value={value}
      onChange={onChange}
      className="form-input"
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

export default Dropdown;